<ng-container *ngIf="externalGptConfig$ | async as externalGptConfig; else loadingTemplate">
  <div mat-dialog-title>
    <span>{{ modalTitle | translate }}</span>
    <q9-dialog-close-button></q9-dialog-close-button>
  </div>

  <q9-credit-balance-warning
    #creditWarning
    [hidden]="!(isFree() || hasSubscription())"
    [actionKey]="'GENERATE_STORY_REQUIREMENT_PER_ITEM_VIA_AI'"
    [multiplier]="plannedStoryCount"></q9-credit-balance-warning>

  <app-explain-rules-content
    *ngIf="step() === 1"
    [externalGptConfig]="externalGptConfig"
    [articleLink]="articleLink"
    (changeStep)="changeStep($event)">
    <span infoText1>{{ 'GPT_STORIES.GENERATE_STORIES_INFO_S1_P1' | translate }}</span>
    <span infoText2>{{ 'GPT_STORIES.GENERATE_STORIES_INFO_S1_P2' | translate }}</span>
  </app-explain-rules-content>

  <app-assign-stories-content
    *ngIf="step() === 2"
    [data]="data"
    [disableSubmit]="!creditWarning.canProceed()"
    (changeStep)="changeStep($event)"></app-assign-stories-content>
</ng-container>

<ng-template #loadingTemplate>
  <q9-content-loader [isLoading]="true"></q9-content-loader>
</ng-template>
